/* eslint-disable no-nested-ternary */
import styled from "styled-components";
import { COLORS } from "../../../utils";

export const Container = styled.div`
  flex: 1;
`;

export const ContainerInput: any = styled.div`
  display: flex;
  height: 44px;
  width: 100%;
  align-items: center;
  padding: ${(props: any) =>
    props.searchIcon === "right"
      ? props.button
        ? "0px"
        : "0 16px 0 0"
      : props.button
      ? "0px"
      : "0 0 0 16px"};
  border-radius: 8px;
  background-color: ${(props: any) =>
    props.disabled ? "rgba(0,0,0,0.08)" : "#ffffff"};
  border-width: ${(props: any) => (props.isFocused ? 2 : 1)}px;
  border-style: solid;
  border-color: ${(props: any) => (props.isFocused ? "#4a76fb" : "#D0D5DD")};
  transition: border-color 0.2s ease-in;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  overflow: hidden;

  .button-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: ${COLORS.primary500};
    height: 100%;
    width: 100%;
    max-width: 45px;
  }
  .button-clear {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: 100%;
    width: 100%;
    max-width: 45px;
  }
  .search-icon {
    ${(props: any) =>
      props.incite &&
      "animation: color-change 1s linear infinite, size-change 1s linear infinite"};
  }
  @keyframes color-change {
    0% {
      color: ${COLORS.primary500};
    }
    50% {
      color: #a3a3a6;
    }
    100% {
      color: ${COLORS.primary500};
    }
  }
  @keyframes size-change {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.15);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const Input = styled.input`
  display: flex;
  height: 42px;
  width: 100%;
  border-radius: 8px;
  background-color: transparent;
  border: none;
  padding: 0 14px 0 14px;
  color: ${(props: any) => (props?.disabled ? "#a0a0a0" : "#333")};
  font-size: 16px;
  :focus {
    border: none;
    -webkit-appearance: none;
    outline: none;
  }
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #a3a3a6;
    opacity: rgba(0, 0, 0, 0.1); /* Firefox */
  }
`;
